export enum MaintenanceTab {
  UsersManagement = 'users',
  MassReplace = 'mass_replace',
  Templates = 'templates',
  UnstagedPacks = 'packs',
  Pricing = 'pricing',
}
